import { memo } from 'react';
import { noop } from 'lodash';
// Import Types
import type { FormikErrors } from 'formik';
// Import Enums
import { LabelAppearanceEnum } from 'enums';
// Import UI Components
import { ExtendedInput } from '@geneui/components';
// Import Components
import RandomComponentWithHeadline from './RandomComponentWithHeadline';

interface Props {
    name?: string;
    label?: string;
    labelAppearance?: LabelAppearanceEnum;
    placeholder?: string;
    inputValue: string | number;
    handleClick?: () => void;
    headline?: string;
    errorText?: string;
    isTouched?: boolean;
    pattern?: string;
    formValue: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void> | Promise<FormikErrors<any>>;
    setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void;
    minValue?: string;
    isInteger?: boolean;
}

const NumberValueInput: React.FC<Props> = (props) => {
    const {
        name,
        inputValue,
        headline,
        handleClick = noop,
        errorText = '',
        isTouched = true,
        pattern = '[1-9][0-9]*',
        formValue,
        setFieldValue,
        setFieldTouched = noop,
        minValue = '0',
        isInteger = false,
        label,
        labelAppearance,
        placeholder,
    } = props;

    const handleValueChange = (e) => {
        const { value } = e.target;
        const tempValue = isInteger ? value.replace('.', '') : value;

        setFieldValue(formValue, tempValue, true).then(() => setFieldTouched(formValue));
    };

    return (
        <RandomComponentWithHeadline className="crm-flex crm-flex-column simple-number-input" headline={headline}>
            <ExtendedInput
                type="number"
                name={name}
                label={label}
                labelAppearance={labelAppearance}
                placeholder={placeholder}
                value={inputValue}
                pattern={pattern}
                onChange={handleValueChange}
                onClick={handleClick}
                min={minValue}
                isValid={!(isTouched && errorText)}
                errorText={isTouched && errorText}
            />
        </RandomComponentWithHeadline>
    );
};

export default memo(NumberValueInput);
